export default {
  title: "Список клиентов",
  allClients: "Все клиенты",
  internalClients: "Внутренние",
  internalClient: "Внутренний",
  externalClients: "Внешние",
  externalClient: "Внешний",
  clientsType: "Тип клиента",

  noEnitity: {
    label: "Страница недоступна",
    text: "Ваше юрлицо находится на модерации",
  },
  needBuyTariff: "Необходимо приобрести тариф, чтобы оцифровывать клиентов",
  noTradingPoint: "У вас пока нет торговых точек",
  digitizeClients:
    "Оцифровывайте клиентов, чтобы они отображались в вашем списке",

  table: {
    inviteDate: "Дата регистрации",
    fullName: "ФИО",
    phone: "Номер телефона",
    receiptsCount: "Кол-во покупок",
    receiptsSum: "Сумма покупок",
  },

  clientCard: {
    title: "Информация о клиенте",
    client: {
      title: "Клиент",
      fields: {
        fullName: "ФИО",
        gender: "Пол",
        birthDate: "Дата рождения",
        phone: "Номер телефона",
        clientType: "Тип клиента",
        inviteDate: "Дата регистрации",
        regSource: "Источник регистрации",
        rcCard: "Номер карты RC",
        note: "Заметка",
      },
      phoneHint:
        "Номер телефона отображается только на платных тарифах и только у тех клиентов, которые дали свое согласие на передачу контактных данных и получение маркетинговых предложений.",
    },
    statistic: {
      title: "Статистика",
      block: {
        avgReceiptsSum: "Средний чек",
        receiptsCount: "Кол-во покупок",
        receiptsSum: "Оборот",
        writeOffPointsSum: "Оплата баллами",
      },
      totalNumberOfVisit: "Общее кол-во посещений",
      firstVisit: "Первое посещение",
      lastVisit: "Последнее посещение",
      visitedShops: "Посещенные заведения",
    },
    receipts: {
      title: "Чеки",
      emptyState: {
        title: "Чеков нет",
        description:
          "Они появятся здесь после <br> совершения клиентом покупки",
      },
    },
    reviews: {
      title: "Отзывы",
      noReviews: "Отзывов пока нет",
      itsAppearHere: "Они появятся здесь, когда <br> клиент оставит отзыв",
    },
  },
  pointsAwarded: "Начислено баллов",
  digitizingOnYourTariffNotAvailable:
    "Оцифровка клиентов на вашем тарифе недоступна",
  digitizingIntoRC: "Оцифровка клиентов<br> через RC PAY",
  fastDigitizingIntoTg: "Ускоренная оцифровка<br> через Telegram-бот",
  abilityToUseLinkOrQRcode:
    "Возможность использовать ссылку или QR-код для приглашения новых пользователей станет доступна после покупки тарифа.",
  inviteClients: "Пригласить клиентов",
  selectPointToGenerateQR:
    "Выберите торговую точку, чтобы сгенерировать ссылку и&nbsp;QR-код для&nbsp;регистрации новых клиентов в&nbsp;RC&nbsp;PAY.",
  invitingtoLoyaltyProgram: "Приглашение в программу лояльности",
  downloadQR: "Скачать QR-код",
  linkCopied: "Ссылка скопирована",
  share: "Поделиться",
  joinToLoyaltyProgram: "Присоединяйся к программе лояльности!",
  receiveDiscountNotifies:
    "Получай уведомления о скидках и эксклюзивных акциях. У нас вознаграждение за каждую покупку и оплата баллами до 99.9%.",
  clientServiceAndAppRcPay:
    "Клиентский сервис rcpay.ru и приложение RC PAY – твои проводники в мир выгодного и комфортного шопинга!",
};
